import '.bx{position:relative;}.ssr-plugin'
import '.u{width:100%;}.ssr-plugin'
import '.gc{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.bq{align-items:flex-start;}.ssr-plugin'
import '.w{padding:2rem;}.ssr-plugin'
import '.d4{background:var(--shades-white);}.ssr-plugin'
import '.q{overflow:hidden;}.ssr-plugin'
import '.m{position:absolute;}.ssr-plugin'
import '.iq{top:50%;}.ssr-plugin'
import '.ir{right:1rem;}.ssr-plugin'
import '.is{transform:translateY(-50%);}.ssr-plugin'
import '.it{width:120px;}.ssr-plugin'
import '.iu{height:120px;}.ssr-plugin'
import '.iv{z-index:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.h6{z-index:1;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import '.iw{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bx u gc a b g bq w d4 q"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="m iq ir is it iu iv a c g"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bx h6 a b bq al iw"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
